export default __webpack_public_path__ + "static/media/bofa.0085c016.svg";